module.exports = __webpack_public_path__ + "img/Header-Option-window.1c2b4dfa.jpg";